<template>
    <router-link class="list-item" :to="to">
        <div
            v-if="icon"
            class="list-item__icon-container"
            :style="{ backgroundColor: iconColor }"
        >
            <div class="list-item__icon">
                <img :src="icon" :alt="primaryText" width="24" height="24" />
            </div>
            <img
                v-if="hasAlert"
                class="list-item__alert"
                :src="require('@/assets/icons/alert.svg')"
                alt="Alert"
            />
        </div>
        <div class="list-item__body">
            <div class="list-item__primary-text">
                {{ primaryText }}
            </div>
            <div class="list-item__secondary-text">
                <slot name="secondaryText">{{ secondaryText }}</slot>
            </div>
        </div>
        <div class="list-item__status">
            <slot name="status"></slot>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'AxRoadListItem',
    props: {
        icon: {
            type: String,
            default: '',
        },
        iconColor: {
            type: String,
            default: 'black',
        },
        primaryText: {
            type: String,
            required: true,
        },
        secondaryText: {
            type: String,
            default: '',
        },
        to: {
            type: [Object, String],
            required: true,
        },
        hasAlert: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
.list-item {
    display: flex;
    gap: 12px;
    padding: 12px;
    margin: 2px 0;
    border-bottom: 1px solid $color-border;
    transition: all 0.3s ease;

    &.router-link-active {
        background-color: $color-gray-lighter-new;
        border-radius: 12px !important;
    }

    &__primary-text {
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
    }

    &__secondary-text {
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__icon-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        min-width: 40px;
        border-radius: 20px;
    }

    &__alert {
        position: absolute;
        top: -4px;
        right: -4px;
    }

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80%;
        height: 80%;
        min-width: 80%;
        border-radius: 50%;
        overflow: hidden;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }

    &__body {
        flex-grow: 1;
        min-width: 160px;
        max-width: calc(100% - 88px);
    }

    &__status {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 5px;
        color: $color-gray;
        font-size: 13px;
        line-height: 20px;
        white-space: nowrap;
    }

    &:hover {
        background-color: $color-gray-light-new;
    }
}
</style>
